import boldFontUrl from "assets/fonts/NotoSansJP-Bold.woff2?url";
import regularFontUrl from "assets/fonts/NotoSansJP-Regular.woff2?url";

export const PUB_PDF_FONT_FAMILY = '"Noto Sans JP", sans-serif';

export const PUB_PDF_FONT_FILES = {
  regular: regularFontUrl,
  bold: boldFontUrl
} as const;
